import { useEffect, useState } from "react";
import TurndownService from "turndown";
import Editor, {
  BtnBold,
  BtnItalic,
  BtnNumberedList,
  type ContentEditableEvent,
  BtnBulletList,
  Toolbar,
  BtnRedo,
  BtnUndo,
} from "react-simple-wysiwyg";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

interface Props {
  initValue: string;
  onChange: (value: string) => void;
}

const mdParser = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
});

const EditorMarkdown = (props: Props): React.ReactNode => {
  const [htmlContent, setHtmlContent] = useState<string>(props.initValue);

  useEffect(() => {
    const initialize = (): void => {
      const html = mdParser.render(props.initValue);
      setHtmlContent(html);
    };
    initialize();
  }, [props.initValue]);

  const convertToMarkdown = (html: string): string => {
    const turndownService = new TurndownService({
      headingStyle: "atx",
      bulletListMarker: "-",
    });
    const md = turndownService.turndown(html);
    return md;
  };

  return (
    <div className="w-full">
      <Editor
        value={htmlContent}
        onChange={(event: ContentEditableEvent) => {
          const value = DOMPurify.sanitize(event.target.value);
          setHtmlContent(value);
          const md = convertToMarkdown(value);
          props.onChange(md);
        }}
      >
        <Toolbar>
          <BtnBold />
          <BtnItalic />
          <BtnNumberedList />
          <BtnBulletList />
          <BtnUndo />
          <BtnRedo />
        </Toolbar>
      </Editor>
    </div>
  );
};

export default EditorMarkdown;
